import {Pipe, PipeTransform} from '@angular/core';
import {RaceRegistration, TypeOfRegistration} from "@model";
import {TranslocoService} from "@ngneat/transloco";

@Pipe({
    name: 'registrationTypeName',
    standalone: false
})
export class RegistrationTypeNamePipe implements PipeTransform {
    constructor(private translocoService:TranslocoService) {
    }

    transform(value?: RaceRegistration): string {
        if (!value) return 'Unknown';
        let typeOfRegistration: TypeOfRegistration = RaceRegistration.getTypeOfRegistration(value);

        switch (typeOfRegistration) {
            case TypeOfRegistration.TEAM:
                return this.translocoService.translate("account.statements.type.of.registration.2");
            case TypeOfRegistration.GROUP:
                return this.translocoService.translate("account.statements.type.of.registration.1");
            default:
                return this.translocoService.translate("account.statements.type.of.registration.0");
        }
    }
}
